import { render } from "./Styleguide-FieldUsage-Number.vue?vue&type=template&id=5ae040bb"
import script from "./Styleguide-FieldUsage-Number.vue?vue&type=script&lang=js"
export * from "./Styleguide-FieldUsage-Number.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__